import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

import { debug } from '@monade/json-api-parser';

debug.adapter = (..._args: any[]) => {};

if (environment.sentryDSN) {
  Sentry.init({
    dsn: environment.sentryDSN,
    environment: environment.environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [environment.endpoint],
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
